import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonInput from "../../components/input/CommonInput";
import CommonButton from "../../components/button/CommonButton";
import Card from "../../components/card";
import HomeHeader from "../../components/header/HomeHeader";
import CommonFooter from "../../components/footer/CommonFooter";
import {
  passwordValidator,
  handleBlanckSpaceInput,
  getErrorMessage,
} from "../../constants/globalFunction";

import { showErrorToast, showSuccessToast } from "../../utils/toast";
import { FaLock } from "react-icons/fa";
import "./ChangePassword.css";
import { appApiHandler } from "../../api/appApiHandler";
import { string } from "../../constants/string";
import Breadcrumb from "../../components/breadcrumb";
import { useSelector } from "react-redux";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const { userData } = useSelector((state) => state.userState);

  const onChangeOldPassword = (text) => {
    setOldPassword(handleBlanckSpaceInput(text));
    if (oldPasswordError) setOldPasswordError("");
  };

  const onChangePassword = (text) => {
    setPassword(handleBlanckSpaceInput(text));
    if (passwordError) setPasswordError("");
  };

  const onChangeConfirmPassword = (text) => {
    setConfirmPassword(handleBlanckSpaceInput(text));
    if (confirmPasswordError) setConfirmPasswordError("");
  };

  const validateValues = () => {
    let isValid = true;

    if (!userData) {
      showErrorToast(string.error.please_login_to_your_account);
      return;
    }

    if (!oldPassword.trim()) {
      setOldPasswordError("Please enter old password");
      isValid = false;
    } else {
      setOldPasswordError("");
    }

    if (!password.trim()) {
      setPasswordError("Please enter password");
      isValid = false;
    } else if (!passwordValidator(password)) {
      setPasswordError(
        "Password must be at least 8 characters and include one uppercase letter, one number, and one special character"
      );
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (!confirmPassword.trim()) {
      setConfirmPasswordError("Please enter confirm password");
      isValid = false;
    } else if (confirmPassword !== password) {
      setConfirmPasswordError("Passwords do not match");
      isValid = false;
    } else {
      setConfirmPasswordError("");
    }

    return isValid;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateValues();

    if (isValid) {
      try {
        const reqData = {
          user_id: userData?._id,
          old_password: oldPassword,
          new_password: password,
        };

        setLoading(true);
        const response = await appApiHandler.changePassword(reqData);
        setLoading(false);

        if (response?.status === 200) {
          showSuccessToast("Password changed successfully");
          navigate(-1);
        } else if (response?.message) {
          showErrorToast(getErrorMessage(response?.message));
        } else {
          showErrorToast(string.error.failed_due_to_internal_error);
        }
      } catch (err) {
        setLoading(false);
        showErrorToast(string.error.failed_due_to_internal_error);
      }
    }
  };

  return (
    <div className="change-password-page">
      <HomeHeader />
      <div className="page-content">
        <Breadcrumb
          items={[
            {
              label: "Home",
              path: "/",
            },
            {
              label: "Change Password",
              isActive: true,
            },
          ]}
        />
         <Card>
        <form onSubmit={onSubmit} >
          <CommonInput
            label="Current Password"
            value={oldPassword}
            onChange={onChangeOldPassword}
            placeholder="Enter current password"
            error={oldPasswordError}
            secureTextEntry={true}
            leftIcon={<FaLock className="change-password-icon" />}
          />

          <CommonInput
            label="New Password"
            value={password}
            onChange={onChangePassword}
            placeholder="Enter new password"
            error={passwordError}
            secureTextEntry={true}
            leftIcon={<FaLock className="change-password-icon" />}
          />

          <CommonInput
            label="Confirm New Password"
            value={confirmPassword}
            onChange={onChangeConfirmPassword}
            placeholder="Enter confirm password"
            error={confirmPasswordError}
            secureTextEntry={true}
            leftIcon={<FaLock className="change-password-icon" />}
          />

          <CommonButton
            title={loading ? "Changing..." : "Change Password"}
            type="submit"
            disabled={loading}
          />
        </form>
      </Card>
      </div>
      <CommonFooter />
    </div>
  );
};

export default ChangePassword;
